export default "__VITE_ASSET__HNXDW8P$__"